import React, { useEffect, useRef, useState } from "react";
import styles from "./service-request-page.module.scss";
import { trackReportIssueOpened } from "../../../services/business-analytics/reportIssueEvents";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
import TextTabs, { TextTabItem } from "../../../common/components/text-tabs/TextTabs";
import OverviewTab from "./tabs/overview-tab/OverviewTab";
import OngoingTab from "./tabs/ongoing-tab/OngoingTab";
import CompletedTab from "./tabs/completed-tab/CompletedTab";

export const ServiceRequestPage: React.FC = () => {
	const [selectedTabIndex, setSelectedTabIndex] = useState(0);
	// Guards against StrictMode's double effect run, so one visit is one event.
	const trackedOpen = useRef(false);

	useEffect(() => {
		if (trackedOpen.current) return;
		trackedOpen.current = true;
		trackReportIssueOpened();
	}, []);

	const tabs: TextTabItem[] = [
		{ title: "Overview", onTap: () => setSelectedTabIndex(0) },
		{ title: "Ongoing", onTap: () => setSelectedTabIndex(1) },
		{ title: "Completed", onTap: () => setSelectedTabIndex(2) },
	];

	return (
		<CustomerPageLayout title="Service Request">
			<div className={styles.pageWrapper}>
				<div className={styles.tabsBar}>
					<TextTabs tabs={tabs} selectedIndex={selectedTabIndex} />
				</div>

				<div className={styles.tabContent}>
					{selectedTabIndex === 0 && <OverviewTab />}
					{selectedTabIndex === 1 && <OngoingTab />}
					{selectedTabIndex === 2 && <CompletedTab />}
				</div>
			</div>
		</CustomerPageLayout>
	);
};

